const lockScreenPageStyle = () => ({
	justifyContentCenter: {
		justifyContent: 'center !important',
		display: 'block',
		textAlign: 'center',
	},
	cardBody: {
		paddingBottom: 46,
		paddingTop: 33,
	},
	loginUnsuccessful: {
		marginBottom: 18,
	},
	footerLinks: {
		marginTop: 120,
		marginBottom: 24,
		'& a': {
			marginLeft: 4,
		},
	},
});

export default lockScreenPageStyle;
